// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__LROgy","content":"styles_content__VOFLd","contentWithPaddings":"styles_contentWithPaddings__HubVB"};